// extracted by mini-css-extract-plugin
export var section = "_2p-1";
export var topNav = "_2p-0";